import React from "react"
import "./SkinSelectRow.css"
import { baseUrlImg } from "../../config/api"

const SkinSelectRow = ({
  skinList = [],
  activeSkinId,
  setActiveSkinId,
  setActiveSkinName,
}) => {
  const handleSelect = (skin) => {
    setActiveSkinId(skin.id)
    setActiveSkinName(skin.username)
  }

  return (
    <div className="skin-badge-row">
  
      <div
        className={`skin-badge ${activeSkinId === -1 ? "active" : ""}`}
        onClick={() => setActiveSkinId(-1)}
      >
        <span className="skin-name">Tutti</span>
      </div>

      {skinList.map((skin) => (
        <div
          key={skin.id}
          className={`skin-badge ${activeSkinId === skin.id ? "active" : ""}`}
          onClick={() => handleSelect(skin)}
        >
          <img
            src={`${baseUrlImg}/icon/${skin.username}-icon.svg`}
            alt={skin.username}
            className="skin-icon"
          />

          <span className="skin-name">{skin.username}</span>
        </div>
      ))}
    </div>
  )
}

export default SkinSelectRow
